import { getTenancyDefaultUrlQuery } from "~/helpers/apollo/apollo-portfolio-filter-helpers";
import type { UrlTabConfig } from "~/helpers/tabs-helpers";

export const useUrlTabsPortfolio = () => {
  const t = useTranslator();

  const defaultFilterQuery = useDefaultTenancyFilterBookmarkQuery();

  return computed<UrlTabConfig[]>(() => [
    { tabKey: "overview", labelKey: "PORTFOLIO_OVERVIEW_PROPERTY_OVERVIEW", default: true },
    { tabKey: "tenancies", labelKey: "PORTFOLIO_OVEVIEW_PROPERTY_TENANCIES", query: getTenancyDefaultUrlQuery(defaultFilterQuery.result.value?.id) },
    { tabKey: "opex", labelKey: "PORTFOLIO_PROPERTY_OPEX" },
    { tabKey: "properties", labelKey: "PORTFOLIO_OVERVIEW_PROPERTIES" },
    { tabKey: "companies", labelKey: "PORTFOLIO_OVERVIEW_COMPANIES" },
    { tabKey: "balance", labelKey: "PORTFOLIO_OVEVIEW_PROPERTY_BALANCE" },
  ]);
};
